import { ConfigProvider } from "antd";
import ruRU from 'antd/locale/ru_RU';
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dictionaries from "./components/common/dictionaries";
import PrivateRoute from "./components/common/private-route";
import ProfilePage from "./components/profile/profile";
import StudentCurrentTicket from "./components/students/student-current-ticket";
import StudentList from "./components/students/student-list";
import MathegeImport from "./components/task/mathege-import";
import TaskAdd from "./components/task/task-add";
import TaskEdit from "./components/task/task-edit";
import TaskList from "./components/task/task-list";
import TicketAdd from "./components/ticket/ticket-add";
import TicketList from "./components/ticket/ticket-list";
import LoginPage from "./login";
import Main from "./main";
import Subjects from "./models/subjects";
import { RootStore, RootStoreContext } from './stores/root-store';

ReactDOM.render(
  <ConfigProvider locale={ruRU}>
    <RootStoreContext.Provider value={new RootStore()}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route path="/" element={<PrivateRoute />}>
            <Route path="" element={<Main />}>
              <Route path="profile" element={<ProfilePage />} />
              {/* <Route path="" element={<TaskList subject={Subjects.MATH} />} /> */}
              
              <Route path="math/tasks/list" element={<TaskList subject={Subjects.MATH} />} />
              <Route path="math/tasks/add" element={<TaskAdd subject={Subjects.MATH} />} />
              <Route path="math/tasks/edit/:taskId" element={<TaskEdit subject={Subjects.MATH} />} />
              <Route path="math/tasks/import" element={<MathegeImport />} />
              <Route path="math/tickets/add" element={<TicketAdd subject={Subjects.MATH} />} />
              <Route path="math/tickets/list" element={<TicketList subject={Subjects.MATH} />} />
              <Route path="math/students/:studentId/tickets/current" element={<StudentCurrentTicket subject={Subjects.MATH} />} />
              <Route path="math/students/:studentId/tickets/:ticketId" element={<StudentCurrentTicket subject={Subjects.MATH} />} />
              <Route path="math/students/list" element={<StudentList subject={Subjects.MATH} />} />
              <Route path="math/dictionaries" element={<Dictionaries subject={Subjects.MATH} />} />

              <Route path="physic/tasks/list" element={<TaskList subject={Subjects.PHYSIC} />} />
              <Route path="physic/tasks/add" element={<TaskAdd subject={Subjects.PHYSIC} />} />
              <Route path="physic/tasks/edit/:taskId" element={<TaskEdit subject={Subjects.PHYSIC} />} />
              <Route path="physic/tickets/add" element={<TicketAdd subject={Subjects.PHYSIC} />} />
              <Route path="physic/tickets/list" element={<TicketList subject={Subjects.PHYSIC} />} />
              <Route path="physic/students/:studentId/tickets/current" element={<StudentCurrentTicket subject={Subjects.PHYSIC} />} />
              <Route path="physic/students/:studentId/tickets/:ticketId" element={<StudentCurrentTicket subject={Subjects.PHYSIC} />} />
              <Route path="physic/students/list" element={<StudentList subject={Subjects.PHYSIC} />} />
              <Route path="physic/dictionaries" element={<Dictionaries subject={Subjects.PHYSIC} />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </RootStoreContext.Provider>
  </ConfigProvider>,
  document.getElementById("root")
);